import script from "./Presentation.vue?vue&type=script&setup=true&lang=js"
export * from "./Presentation.vue?vue&type=script&setup=true&lang=js"

import "./Presentation.vue?vue&type=style&index=0&id=70056bbb&lang=css"

const __exports__ = script;

export default __exports__